import { render, staticRenderFns } from "./AppAlertsCoaSensor.vue?vue&type=template&id=4ddea6e5&scoped=true&"
import script from "./AppAlertsCoaSensor.vue?vue&type=script&lang=js&"
export * from "./AppAlertsCoaSensor.vue?vue&type=script&lang=js&"
import style0 from "./AppAlertsCoaSensor.vue?vue&type=style&index=0&id=4ddea6e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddea6e5",
  null
  
)

export default component.exports